export default "__VITE_ASSET__Cpo4QbCA__"